import { inject, injectable } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';

@injectable()
class BreadcrumbsRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher) {}

  getBreadcrumbs = async (viewId: number) => {
    const request = new Request('finsight_web.frontend.finsight.get_breadcrumbs', {
      issuerViewId: viewId,
    });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default BreadcrumbsRepository;
